import React, { useState } from 'react'
import { Tenant } from '../../Interfaces/Types'
import Button2 from '@embracesbs/component-button2/Button2'
import Icon from '@embracesbs/component-icon/Icon'
import { useApi } from '../../Hooks'

interface SupportLoginDetailsProbs {
  tenant?: Tenant
  variant?: 'contained' | 'outlined' | 'subtle' | 'subtleColored'
  isFullWidth?: boolean
}

//Those full urls should come from backend and not hardcoded
const SupportLogin: React.FC<SupportLoginDetailsProbs> = ({ tenant, variant = 'contained', isFullWidth = false }) => {
  const [buttonText, setButtonText] = useState('Support Login')
  const [isCopied, setIsCopied] = useState(false)
  const { fetchApi } = useApi()

  const getSupportUrl = async (): Promise<string> => {
    const data = await fetchApi({
      endpoint: `/api/tenant/${tenant?.id}/tenantsconfiguration/supporturl`,
      method: 'GET'
    })

    const loginUrl = data?.loginUrl
    const keycloakUrl = data?.keycloakUrl

    if (!loginUrl) {
      throw new Error('loginUrl is missing from the response')
    }

    if (!keycloakUrl) {
      throw new Error('keycloakUrl is missing from the response')
    }

    return `${keycloakUrl}/auth/realms/${tenant?.tenantName}/protocol/openid-connect/auth?client_id=embracecloud&redirect_uri=${loginUrl}&response_type=code&scope=openid+suite-user+identity-provider-user&kc_idp_hint=support`
  }

  const handleLogin = () => {
    setButtonText('Loading...')
    getSupportUrl()
      .then((supportUrl) => {
        window.open(supportUrl, '_blank', 'noopener noreferrer')
      })
      .catch((error) => {
        console.error(error)
      })
      .finally(() => {
        setButtonText('Support Login')
      })
  }

  const handleCopy = () => {
    getSupportUrl()
      .then((supportUrl) => navigator.clipboard.writeText(supportUrl))
      .then(() => {
        setIsCopied(true)
        setTimeout(() => setIsCopied(false), 2000)
      })
      .catch((error) => {
        console.error(error)
      })
  }

  return (
    <div
      style={
        isFullWidth
          ? { display: 'flex', width: '100%', gap: '1px' }
          : { display: 'inline-flex', gap: '1px', marginRight: '1rem', marginLeft: '1rem' }
      }
    >
      <Button2
        style={{
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
          ...(isFullWidth ? { flex: 1 } : { minWidth: '260px', flexShrink: 0 })
        }}
        buttonRadius='8px'
        buttonSize='30px'
        leftElement={<Icon iconName='Login2' size={16} />}
        onClick={handleLogin}
        text={buttonText}
        variant={variant}
        isDisabled={!tenant}
      />
      <Button2
        style={{
          width: '38px',
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          borderTopRightRadius: '8px',
          borderBottomRightRadius: '8px',
          flexShrink: 0
        }}
        buttonRadius='8px'
        buttonSize='30px'
        leftElement={<Icon iconName={isCopied ? 'CheckThick' : 'CopyPaste'} size={16} />}
        onClick={handleCopy}
        aria-label='Copy support login link'
        tooltip={isCopied ? 'Copied!' : 'Copy support login link'}
        tooltipPlace='top'
        variant={variant}
        isDisabled={!tenant}
      />
    </div>
  )
}

export default SupportLogin
